var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90287 0.00427776L5.97437 0C6.12405 1.97453e-05 6.26852 0.0549732 6.38037 0.154437C6.49223 0.253901 6.56369 0.390958 6.5812 0.539611L6.58548 0.611111V4.88889H10.8633C11.0129 4.88891 11.1574 4.94386 11.2693 5.04333C11.3811 5.14279 11.4526 5.27985 11.4701 5.4285L11.4744 5.5C11.4743 5.64968 11.4194 5.79415 11.3199 5.90601C11.2205 6.01786 11.0834 6.08932 10.9348 6.10683L10.8633 6.11111H6.58548V10.3889C6.58546 10.5386 6.5305 10.683 6.43104 10.7949C6.33158 10.9067 6.19452 10.9782 6.04587 10.9957L5.97437 11C5.82468 11 5.68021 10.945 5.56836 10.8456C5.45651 10.7461 5.38504 10.609 5.36753 10.4604L5.36325 10.3889V6.11111H1.08548C0.935795 6.11109 0.791326 6.05614 0.679471 5.95667C0.567617 5.85721 0.496156 5.72015 0.478643 5.5715L0.474365 5.5C0.474385 5.35032 0.529338 5.20585 0.628802 5.09399C0.728266 4.98214 0.865323 4.91068 1.01398 4.89317L1.08548 4.88889H5.36325V0.611111C5.36327 0.46143 5.41823 0.316961 5.51769 0.205106C5.61716 0.0932513 5.75421 0.0217905 5.90287 0.00427776L5.97437 0L5.90287 0.00427776Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.b927b337cf3a0dcc6446864758724dff.svg";
export { ForwardRef as ReactComponent };